<div class="modal-header">
  <h4 class="modal-title">{{ "sphere.workspaces.manage_collaborators" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="manageCollabsLoader"></myp-inline-loader>

  @if (!loading && !adding) {
    <div class="t-14">
      <strong>{{ "sphere.workspaces.invite_anyone_to_workspace" | translate }}</strong>
      <br />
      <br />
      <strong>{{ "sphere.workspaces.you_can_grant" | translate }}</strong>
      <br />
      <br />
      <strong>{{ "sphere.workspaces.admin" | translate }}:</strong>
      {{ "sphere.workspaces.admin_def" | translate }}
      <br />
      <strong>{{ "sphere.workspaces.contributor" | translate }}:</strong>
      {{ "sphere.workspaces.contributor_def" | translate }}
      <br />
      <strong>{{ "sphere.workspaces.browser" | translate }}:</strong>
      {{ "sphere.workspaces.browser_def" | translate }}
      <br />
    </div>
    @for (item of collaborators; track item; let i = $index) {
      <div class="list-item">
        @if (item.user_id != user.id) {
          <div class="list-item-container">
            <img [src]="item.photo || './assets/images/default_avatar.jpg'" class="item-image" />
            <div class="main-data">
              {{ item.name || item.email }}
              <br />
              <span class="sub-data">
                {{ "sphere.workspaces.permissions" | translate }}:
                @if (!item.editing) {
                  <span>{{ item.role | uppercase }}</span>
                }
                @if (item.editing) {
                  <select (change)="updateRole(item, $event)">
                    <option value="admin" [selected]="item.role == 'admin'">{{ "sphere.workspaces.admin" | translate }}</option>
                    <option value="contributor" [selected]="item.role == 'contributor'">{{ "sphere.workspaces.contributor" | translate }}</option>
                    <option value="browser" [selected]="item.role == 'browser'">{{ "sphere.workspaces.browser" | translate }}</option>
                  </select>
                }
                <div>
                  <span [class.c-green]="item.status == 'approved'" [class.c-orange]="item.status == 'pending'" [class.c-red]="item.status == 'denied'">
                    {{ "sphere.account.status" | translate }}: {{ item.status | uppercase }}
                  </span>
                </div>
              </span>
            </div>
            <div class="right-data-buttons">
              @if (!item.editing) {
                <fa-icon icon="edit" class="action circle-icon-btn m-r-5" (click)="item.editing = true"></fa-icon>
              }
              @if (!item.editing) {
                <fa-icon icon="times" class="action circle-icon-btn" (click)="delete(item, i)"></fa-icon>
              }
              @if (item.editing) {
                <fa-icon icon="check" class="action circle-icon-btn" (click)="item.editing = false"></fa-icon>
              }
            </div>
          </div>
        }
      </div>
    }
    <button type="button" class="btn btn-primary m-t-20" (click)="adding = true">{{ "sphere.workspaces.add_collaborator" | translate }}</button>
  }
  @if (!loading && adding && !successfulAdd) {
    <div>
      <strong>{{ "sphere.workspaces.collab_enter_email" | translate }}</strong>
      <br />
      <br />
      {{ "sphere.workspaces.collab_note" | translate }}
      <br />
      <br />
      <input type="email" class="form-control w-full" id="email" (keyup.enter)="invite()" [(ngModel)]="searchEmail" [placeholder]="'sphere.workspaces.enter_email_dots' | translate" />
      <br />
      <button type="submit" class="btn btn-primary mb-2" (click)="invite()">{{ "sphere.workspaces.invite" | translate }}</button>
    </div>
  }
  @if (!loading && successfulAdd) {
    {{ userExists ? ("sphere.workspaces.user_invited" | translate) : ("sphere.workspaces.non_user_invited" | translate) }}
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
